import React from "react";
import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";
import MultiColumnTable from "../../components/common/MultiColumnTable";
import TruncateText from "../../components/common/TruncateText";

export interface InversionSolutionSourcesTabProps {
  sourceSolutions: readonly (
    | {
        readonly __typename?: string;
        readonly file_name?: string | null | undefined;
        readonly file_url?: string | null | undefined;
        readonly id?: string;
      }
    | null
    | undefined
  )[];
}

const TabContainer = styled(Container)(() => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "left",
}));

const InversionSolutionDetailTab: React.FC<InversionSolutionSourcesTabProps> = ({
  sourceSolutions,
}: InversionSolutionSourcesTabProps) => {
  return (
    <TabContainer>
      <MultiColumnTable
        title="Source Models"
        renderers={[
          (row) => <TruncateText key={Object(row)["file_name"]} text={Object(row)["file_name"]} />,
          (row) => <Link to={Object(row)["file_url"]}>Get file</Link>,
          (row) => <Link to={viewPath(Object(row)["id"])}>[more]</Link>,
        ]}
        styles={[{ width: "80%" }, { width: "80px", whiteSpace: "nowrap" }, { width: "80px", whiteSpace: "nowrap" }]}
        rows={sourceSolutions}
      />
    </TabContainer>
  );
};

export default InversionSolutionDetailTab;
